import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSortModule } from '@angular/material/sort';
import {
  MAT_TOOLTIP_DEFAULT_OPTIONS,
  MatTooltipModule,
} from '@angular/material/tooltip';
import { TunnelSanteI18nModule } from '@wz-i18n';
import { TunnelSanteIconModule } from '@wz-icon';
import { TunnelSanteLayoutModule } from '@wz-layout';
import { wzCoreMatTooltipDefaultOptions } from '../tunnelsante/wz-core/wz-core-material-exports';
import { wzUiIconExports } from './wz-ui/icon-exports';
import {
  wzUiExportedComponents,
  wzUiExportedDirectives,
  wzUiExportedEntry,
  wzUiExportedPipes,
} from './wz-ui/wz-ui-exports';

@NgModule({
  imports: [
    TunnelSanteIconModule,
    TunnelSanteI18nModule,
    TunnelSanteLayoutModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatProgressBarModule,
    MatRippleModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatSortModule,
    MatPaginatorModule,
    MatDividerModule,
    MatTooltipModule,
    MatRadioModule,
    MatDialogModule,
  ],
  declarations: [
    wzUiExportedComponents,
    wzUiExportedDirectives,
    wzUiExportedPipes,
    wzUiIconExports,
    ...wzUiExportedEntry,
  ],
  exports: [
    ...wzUiIconExports,
    ...wzUiExportedComponents,
    ...wzUiExportedDirectives,
    TunnelSanteIconModule,
    MatSortModule,
    MatDialogModule,
    MatButtonModule,
    ...wzUiIconExports,
    ...wzUiExportedPipes,
    ...wzUiExportedEntry,
  ],
  providers: [
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: wzCoreMatTooltipDefaultOptions,
    },
  ],
})
export class TunnelSanteUiModule {}
